const enGB = {
    'global': {
        'default': {
            'refresh': 'Refresh',
            'all': 'All',
            'back': 'Back',
        },
    },
    'TopdataContactLoginSW6': {
        'loginLog': {
            'module': {
                'name': 'Login & Activity Logs',
                'title': 'Login & Activity Logs',
                'description': 'View logs of login attempts and password reset activities',
            },
            'list': {
                'title': 'Login & Activity Logs',
                'buttonDownloadCsv': 'Download CSV',
                'exportError': 'Failed to export CSV',
                'buttonClear': 'Clear',
                'clearModalTitle': 'Clear login log',
                'clearModalBody': 'Are you sure you want to delete all login log entries? This action cannot be undone.',
                'clearModalConfirm': 'Yes, clear all',
                'clearSuccess': 'Login log has been cleared',
                'clearError': 'Failed to clear login log',
                'filter': {
                    'attemptType': 'Activity Type',
                    'success': 'Status',
                },
                'searchEmailPlaceholder': 'Search by email address…',
                'column': {
                    'email': 'Email',
                    'attemptType': 'Activity Type',
                    'success': 'Status',
                    'errorMessage': 'Error Message',
                    'createdAt': 'Date',
                },
            },
            'detail': {
                'title': 'Activity Log Entry',
                'card': {
                    'logInfo': 'Activity Details',
                    'customerInfo': 'Customer Information',
                },
                'label': {
                    'email': 'Email Address',
                    'attemptType': 'Activity Type',
                    'success': 'Status',
                    'errorMessage': 'Error Message',
                    'createdAt': 'Date',
                    'ipAddress': 'IP Address',
                    'userAgent': 'User Agent',
                    'customerName': 'Customer Name',
                    'customerEmail': 'Customer Email',
                },
                'notFound': 'Log entry not found',
            },
            'attemptType': {
                'login': 'Login',
                'login_success_customer': 'Login (Customer)',
                'contact_login': 'Login (Contact)',
                'password_reset_request': 'Password Reset Request',
                'password_reset': 'Password Reset',
            },
            'success': {
                '1': 'Success',
                '0': 'Failed',
            },
            'errorMessage': {
                'email_not_found': 'No customer or contact found with that email',
                'contact_not_found': 'No customer or contact found with that email',
                'customer_or_contact_not_found': 'No customer or contact found with that email',
                'invalid_password': 'Invalid password',
                'parent_customer_inactive': 'Parent customer inactive',
            },
        },
    },
};

export default enGB;
